/**
 * Wires every `[data-quick-add]` button (product cards in collection/search/
 * product-rail grids) to add that card's variant straight to the cart
 * without leaving the grid.
 *
 * Only rendered on cards without an iPhone-model option
 * (snippets/product-card.liquid) - this theme treats "which iPhone do you
 * have" as a decision the shopper must make on the PDP, never guessed from
 * a remembered model (the same rule assets/product-form.js's model-confirm
 * panel follows), so model-gated products keep their existing "choose your
 * model" card treatment instead of a quick-add button that would have to
 * guess.
 *
 * DOM contract: button carries `data-quick-add`, `data-variant-id`,
 * `data-cart-add-url`, `data-error-text`.
 *
 * Uses the same Section Rendering flow as assets/cart.js/product-form.js:
 * posts `sections` (every `[data-section-id]` present on the page)
 * alongside the variant id, then hands the response to
 * `window.vellumCart.applySections(..., { forceDrawerOpen: true })` and
 * dispatches `vellum:cart-updated`. Falls back to a full reload with the
 * `vellum:openCartDrawer` sessionStorage flag when Section Rendering data
 * isn't present.
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button || button.disabled) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  const cartAddUrl = button.dataset.cartAddUrl;
  if (!variantId || !cartAddUrl) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.setAttribute('data-loading', '');

  try {
    const sectionIds = Array.from(document.querySelectorAll('[data-section-id]'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.description || button.dataset.errorText);

    if (document.body.dataset.cartType === 'page') {
      window.location.href = `${window.Shopify.routes.root}cart`;
      return;
    }

    if (window.vellumCart && data.sections) {
      window.vellumCart.applySections(data.sections, { forceDrawerOpen: true });
      window.dispatchEvent(new CustomEvent('vellum:cart-updated'));
    } else {
      window.sessionStorage.setItem('vellum:openCartDrawer', '1');
      window.location.reload();
      return;
    }

    button.disabled = false;
    button.removeAttribute('data-loading');
    button.textContent = originalLabel;
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('data-loading');
    button.textContent = button.dataset.errorText || originalLabel;
    window.setTimeout(() => {
      button.textContent = originalLabel;
    }, 3000);
  }
});
